import React, { FormEvent } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { HospitalQueryParams } from './hooks/useFetchHospitals';
import FilterBox from 'components/filter-box/FilterBox';
import CnpjInput from 'components/masked-input/CnpjInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 300px 100px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type HospitalFilterBoxProps = {
  filter: HospitalQueryParams;
  handleChange(index: keyof HospitalQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const HospitalFilterBox: React.FC<HospitalFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Hospital"
          placeholder="Digite o nome do hospital"
          value={filter.company_name}
          autoFocus
          onChange={e => handleChange('company_name', e.target.value)}
        />

        <TextField
          fullWidth
          label="CNPJ"
          placeholder="Digite o CNPJ do hospital"
          value={filter.document_number}
          onChange={e => handleChange('document_number', e.target.value)}
          slotProps={{
            input: {
              inputComponent: asInputComponent(CnpjInput),
            },
          }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={filter.active}
              onChange={e => handleChange('active', e.target.checked)}
              color="primary"
            />
          }
          label="Ativos"
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default HospitalFilterBox;
